import { clsx } from "../../utils/clsx";
import { ScrollArea, type ScrollAreaProps } from "../scroll-area/scroll-area";

interface ModalContentProps extends ScrollAreaProps {
  scrollable?: boolean;
}

export const ModalContent = ({ className, children, scrollable = true, ...rest }: ModalContentProps) => {
  if (!scrollable) {
    return <div className={clsx("px-4 pb-[22px] [grid-area:content] sm:px-10", className)}>{children}</div>;
  }

  return (
    <ScrollArea
      className="[grid-area:content]"
      viewportClassName="overflow-scroll size-full"
      contentClassName={clsx("w-[unset] px-4 pb-[22px] sm:px-10", className)}
      {...rest}
    >
      {children}
    </ScrollArea>
  );
};
